import { render, staticRenderFns } from "./addContractPrice.vue?vue&type=template&id=1080016c&scoped=true&"
import script from "./addContractPrice.vue?vue&type=script&lang=js&"
export * from "./addContractPrice.vue?vue&type=script&lang=js&"
import style0 from "./addContractPrice.vue?vue&type=style&index=0&id=1080016c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080016c",
  null
  
)

export default component.exports